<div
  class="mbs-radio"
  mbs-input-label
  [boldLabel]="boldLabel"
  [class.-lg]="size === 'lg'"
  [class.-sm]="size === 'sm'"
  [center]="centerRadio"
  [disabled]="disabledState"
  [id]="id"
  [info]="info"
  [infoContainer]="infoContainer"
  [infoPlacement]="infoPlacement"
  [infoTriggers]="infoTriggers"
  [label]="label"
  [labelClasses]="labelClasses"
  [labelContext]="labelContext"
  [labelContentClasses]="labelContentClasses"
  [labelPosition]="labelPosition"
  [labelSize]="labelSize"
  [required]="hasRequiredValidator && showRequiredMark"
  [type]="'radio'">
  <ng-content
    ngProjectAs="[prependLabel]"
    select="[prependLabel]" />
  <input
    class="mbs-radio_input"
    [type]="'radio'"
    [checked]="checked"
    [disabled]="disabledState"
    [id]="id"
    [name]="name"
    [tabindex]="tabindex"
    [value]="value"
    (change)="handleChange($any($event))" />

  <ng-content />
  <ng-content
    ngProjectAs="[appendLabel]"
    select="[appendLabel]" />
</div>

@if (subtitle && !subtitleHide) {
  <div
    class="mbs-radio_subtitle"
    [class.-disabled]="disabledState"
    [class.-inside]="!subtitleOutside"
    [class.-lg]="!subtitleOutside && size === 'lg'"
    [class.-sm]="!subtitleOutside && size === 'sm'"
    [ngClass]="subtitleClasses">
    {{ subtitle }}
  </div>
}

@if (radioDescription && !radioDescription.hide) {
  <div
    class="mbs-radio_description"
    [class.-inside]="!descriptionOutside"
    [class.-lg]="!descriptionOutside && size === 'lg'"
    [class.-sm]="!descriptionOutside && size === 'sm'"
    [ngClass]="descriptionClasses">
    <ng-template [ngTemplateOutlet]="radioDescription.template" />
  </div>
}
